<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Form Input</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content" *ngIf="isBrowser">
  <form [formGroup]="formElement" (ngSubmit)="onSubmit()" id="form1">
    <div class="text-center mb-4">
      <h2>Reactive form :: Input </h2>
    </div>


    <maced-input placeholder="Nombre completo" autocomplete="on" inputId="input1" name="input1" type="text" [disabled]="false"
      label="Nombre completo" formControlName="inputVal">
      <ng-container ngProjectAs="[message]">
        <div class="c-input-group__help-text">
          This is helper text
        </div>
      </ng-container>
    </maced-input>

    <p>
      Result:- {{ formElement.value.inputVal }}
    </p>

    <maced-input placeholder="ईमेल पता" inputId="input3" autocomplete="off" name="input3" type="email" [required]="true" [disabled]="false"
      label="ईमेल पता" [pattern]="'[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}'" formControlName="emailVal"
      [hasError]="(formElement.controls.emailVal.touched || submitted) && formElement.controls.emailVal.errors?.required || formElement.controls.emailVal.errors?.email"
      [icon]="(formElement.controls.emailVal.touched || submitted) && formElement.controls.emailVal.errors?.required ? 'icon-alert-triangle' : ''">
      <ng-container ngProjectAs="[message]">
        <div role="alert" class="c-input-group__error"
          *ngIf="(formElement.controls.emailVal.touched || submitted) && formElement.controls.emailVal.errors?.required || formElement.controls.emailVal.errors?.email">
          email field is required
        </div>
      </ng-container>
    </maced-input>

    <p>
      Result:- {{ formElement.value.emailVal }}
    </p>

    <maced-input placeholder="Password" inputId="input4" autocomplete="off" name="input4" type="password" [required]="true"
      [disabled]="false" label="Password" formControlName="passwordVal" [isPasswordInput]="true"
      [showHidePasswordLabel]="showHidePasswordLabelEnglish"
      [hasError]="(formElement.controls.passwordVal.touched || submitted) && formElement.controls.passwordVal.errors?.required"
      [icon]="(formElement.controls.passwordVal.touched || submitted) && formElement.controls.passwordVal.errors?.required ? 'icon-alert-triangle' : ''">
      <ng-container ngProjectAs="[message]">
        <div role="alert" class="c-input-group__error"
          *ngIf="(formElement.controls.passwordVal.touched || submitted) && formElement.controls.passwordVal.errors?.required">
          password field is required
        </div>
      </ng-container>
    </maced-input>

    <p>
      Result:- {{ formElement.value.passwordVal }}
    </p>
    <h2>Reactive form with formID</h2>
    <maced-input placeholder="Nombre completo" autocomplete="on" inputId="input2" name="input2" type="text" [disabled]="false"
    label="Nombre completo" formControlName="formId" formID="form1">
    <ng-container ngProjectAs="[message]">
      <div class="c-input-group__help-text">
        This is helper text
      </div>
    </ng-container>
  </maced-input>

  <p>
    Result:- {{ formElement.value.formId }}
  </p>
    <maced-button buttonId="submit1" form="form1" label="Submit" buttonType="submit"></maced-button>
  </form>

  <maced-input placeholder="Im disable" autocomplete="off" inputId="input5" name="input5" type="text" icon="icon-maximize"
    [required]="false" [disabled]="true" value='' label="Im disable" formID="form1">
  </maced-input>
</div>

<div class="content" *ngIf="!isBrowser">
  <h2>No JS :: Input</h2>

  <form action="/formElement" method="get" id="form2">
    <maced-input placeholder="Im NOJS" autocomplete="off" inputId="noJsInput" name="noJsInput" type="text" [required]="true"
      [disabled]="false" label="Im NOJS" [(ngModel)]="inputNgModelNojs" formID="form2">
    </maced-input>
    <maced-button buttonId="submit2" form="form2" label="Submit" buttonType="submit"></maced-button>
  </form>
  <div>
    <h4>Result</h4>
    <div>
      Input value:-&nbsp;
      {{ inputNgModelNojs }}
    </div>
  </div>
</div>